<template>

	<section>

		<div class="masthead" :style="{backgroundImage: 'url('+mastheadBackgroundImage+')'}">
			<div class="masthead__content">
				<h1><slot name="headline" /></h1>
				<h3><slot name="sub-headline" /></h3>
			</div>
		</div>

		<div class="header">
			<slot name="header" />
		</div>

		<div class="body">
			<slot name="body" />
		</div>

		<div class="footer">
			<slot name="footer" />
		</div>

	</section>

</template>

<script>

	export default {
		name: "layout",
		props: {
			mastheadBackgroundImage: String
		}
	}

</script>

<style lang="scss" scoped>

	@import "media.scss";

	.masthead {
		display:flex; flex:1; flex-direction:column; justify-content:center; align-items:center; position:relative; text-align:center; padding:10rem 5vw 3rem;
		@include media (large) {
			padding:21rem 0 15rem;
		}
		&__content {
			max-width:112.7rem; margin:0 auto; position:relative;
		}
		h1 {
			font-size:3.5rem; line-height:1.16; color:#ffffff; font-weight:400; text-transform:uppercase;
			@include media(large) {
				font-size:5.5rem;
			}
		}
		&:before {
			position:absolute; left:0; right:0; top:0; bottom:0; background:rgba(#000, .2); content:'';
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/OurCompany/layout.vue